import BaseRequest from '../BaseRequest'

export default class TmatsuokaRequest extends BaseRequest {
  completedPatientVisit (params) {
    return this.post(`go/service/sync-tmatsuoka/complete`, params)
  }
}
